module.exports = __webpack_public_path__ + "img/google-marker.3bae5390.svg";